import { FC, useState } from 'react';
import history from 'service/customHistory';
import { useRecoilValue } from 'recoil';

import { ROUTE } from 'common/constants';
import { HELP_ROUTE } from 'components/help/constants';
import ELEMENT from 'common/element';
import { Parser, Permission } from 'common/graphqlTypes';
import { accountDataState, hasPermissionState } from 'components/account/account.state';

import Page from 'components/common/Page/Page';
import PageHeader from 'components/common/PageHeader/PageHeader';

import NewParserDialog from './Dialogs/NewParserDialog';
import ParsersTable from './ParsersTable/ParsersTable';

const ParsersPage: FC = () => {
  const [newParserDialogIsOpen, setNewParserDialogIsOpen] = useState(false);
  const onModifyParser = (parserId: Parser['id']): void => {
    history.push({
      pathname: ROUTE.PARSER,
      search: `?parser=${parserId}`,
    });
  };

  const accountData = useRecoilValue(accountDataState);
  const { isSingularityXDRUser = false } = accountData;

  const hasFullAccessPermission = useRecoilValue(hasPermissionState(Permission.fullAccess));
  const hasXdrUserPermission = useRecoilValue(hasPermissionState(Permission.xdrUser));

  function hasRequiredPermissions(): boolean {
    return (!isSingularityXDRUser && hasFullAccessPermission) || (isSingularityXDRUser && hasXdrUserPermission);
  }

  const buttons = [
    {
      name: ' Add Parser',
      onClick: (): void => {
        setNewParserDialogIsOpen(true);
      },
      disabled: !hasRequiredPermissions(),
      testId: ELEMENT.addParserButton,
    },
  ];

  return (
    <Page docTitle="Parsers" testId={ELEMENT.parsersPage}>
      <PageHeader title="Parsers" helpLink={HELP_ROUTE.HELP_PARSING_LOGS} additionalRightButtons={buttons} />

      <ParsersTable onModifyParser={onModifyParser} />
      <NewParserDialog
        newParserDialogIsOpen={newParserDialogIsOpen}
        setNewParserDialogIsOpen={setNewParserDialogIsOpen}
        onModifyParser={onModifyParser}
      />
    </Page>
  );
};

export default ParsersPage;
